(function($, B) {

    function parallax(){
        var defOptions = {
            parallaxDirection: 1,
            parallaxSpeed: 1,
            backgroundSize: null
        };
        $('.parallax-js').each(function(){
            var $parallax = $(this),               
                parallaxBajt = {
                    $element: $parallax,
                    element: $parallax[0],
                    oryginalBGPosY: $parallax.css('background-position-y'),
                    options: $.extend(true, defOptions, $parallax.data()),
                    limit: {
                        min: 0,
                        max: 0
                    },
                    img : {
                        name: 'img',
                        width : this.width,
                        height : this.height,
                        ratio : this.width / this.height   
                    },
                    cover: {
                        name: 'cover',
                        width:1,
                        height:1,
                        scale:1,
                        start:0
                    },
                    refreshLimits:function(){
                        this.limit.min = this.element.offsetTop - window.innerHeight;
                        this.limit.max = this.element.offsetTop + this.element.offsetHeight;
                    },   
                    refreshCover: function(){
                        this.cover.scale = Math.max(this.element.offsetWidth / this.img.width, this.element.offsetHeight / this.img.height);                                               
                        // this.cover.width = Math.round(this.cover.scale * this.img.width);
                        this.cover.width = this.cover.scale * this.img.width;
                        // this.cover.height = Math.round(this.cover.scale * this.img.height);    
                        this.cover.height = this.cover.scale * this.img.height;    
                        this.cover.start = 0;
                        switch(this.oryginalBGPosY){
                            case '100%':
                                this.cover.start = this.cover.height - this.element.offsetHeight;
                            break;
                            case '50%':
                                // this.cover.start = Math.round((this.element.offsetHeight - this.cover.height) / 2);
                                this.cover.start = (this.element.offsetHeight - this.cover.height) / 2;
                            break;
                            case '0%':
                                this.cover.start = 0;
                            break;
                            default:
                                this.cover.start = this.cover.start(parseInt(this.oryginalBGPosY));
                        }
                        this.setBGPosY();
                    },
                    resize: function(){
                        this.refreshCover();
                        this.refreshLimits();
                    },
                    setBGPosY:function(position){
                        this.element.style.backgroundPositionY = (undefined !== position ? position : this.cover.start) + 'px';    
                    },
                    getBGPosY:function(){
                        var py = parseInt(this.element.style.backgroundPositionY);
                        return isNaN(py) ? this.cover.start : py;
                    },
                    scroll:function(){
                        var o = this.options,
                            sp = window.pageYOffset,
                            py = this.getBGPosY();
                        var log = {
                                a_cover_height: this.cover.height,
                                b_height: this.element.offsetHeight,
                                c_cover_start: this.cover.start,
                                d_first_py: py,
                                e_scroll: sp,
                                f_obl_py: null,
                                g_popr_py: null
                            };
    
                        if (this.limit.min <= sp  && sp <= this.limit.max){
                            py = parseInt(this.cover.start + o.parallaxDirection*sp*o.parallaxSpeed);
                            log.f_opy = py;
                            if(py >= 0){
                                py = 0;
                            }else if(this.element.offsetHeight - py > this.cover.height){
                                py = this.element.offsetHeight - this.cover.height;
                            }
                            log.g_py = py;
                            this.setBGPosY(py);
                        }else{
                            log.h_reset = true;
                            this.setBGPosY();
                        }
                        // console.log(log);
                    }
                };

            var bgImage = new Image();
            bgImage.onload=function(){
                parallaxBajt.img = {
                    width : this.width,
                    height : this.height,
                    ratio : this.width / this.height
                };
                parallaxBajt.resize();
            };
            bgImage.src = $parallax.css('background-image').replace('url(','').replace(')','').replace(/\"/gi, '');
    
            $parallax.data('parallaxBajt', parallaxBajt);


        });
    }

    function resizeParallax(){
        $('.parallax-js').each(function(){
            var $parallax = $(this),
                parallax = $parallax.data('parallaxBajt');
            parallax.resize();
        });
    }

    function scrollParallax(){
        $('.parallax-js').each(function(){
            var $parallax = $(this),
                parallax = $parallax.data('parallaxBajt');
            parallax.scroll();
        });
    }



    B.web.onReady['paralaxJS'] = parallax;
    B.web.onResize['paralaxJS'] = resizeParallax;
    B.web.onScroll['paralaxJS'] = scrollParallax;


    // window.addEventListener('scroll', function(){
    //     var scrollPosition = window.pageYOffset;
    //     var bgParallax = document.getElementsByClassName('parallax')[0];
    //     var limit = bgParallax.offsetTop + bgParallax.offsetHeight;  
    //     if (scrollPosition > bgParallax.offsetTop && scrollPosition <= limit){
    //       bgParallax.style.backgroundPositionY = (50 - 10*scrollPosition/limit) + '%';   
    //     }else{
    //       bgParallax.style.backgroundPositionY = '50%';    
    //     }
    //   });

})(jQuery, Bajt);

